import React from 'react'
import styled from 'styled-components'
import { colors, sans, md } from '../common'

const Message = ({ title, message, css, children }) => {
  return(
    <Section css={css}>
      <Copy dangerouslySetInnerHTML={{ __html: message }} />
      {children}
    </Section>
  )
}

const Section = styled.div`
  background-image:url('https://s3.us-east-2.amazonaws.com/kings-jewelers/medis/logoBG-sm.png');
  background-position:center;
  min-height:150px;
  background-repeat:no-repeat;
  width: 100%;
  text-align: center;
  color: ${colors.brownDark};
`

const Copy = styled.div`
  padding: 2rem 8rem 2rem 8rem;
  line-height: 20px;
  ${sans};
  ${ props => props.css };

  ${md} {
    padding: 1rem;
  }
`

export default Message
